export enum FILE_TYPE {
    IMAGE = 1,
}

export enum DEPOSIT_REVIEW_STATUS {
    WAITING = 0,
    LOCK = 1,
    WAITING_PAYMENT = 2,
    REJECT = 4,
    SUCCESS = 5,
    FAILED = 6,
}

export enum OFFLINE_PAYMENT_TYPE {
    BANK = 'UNION_PAY',
    USDT = 'USDT_PAY',
}

export enum WITHDRAW_REVIEW_STATUS {
    WAIT = 0,
    // 审核中
    // 待审核锁定中 = 1,
    // 待出款 = 2,
    // 处理中
    LOCK = 1,
    WAITING_PAYMENT = 2,
    CHANNEL_PAY_FAILED = 3,
    // 出款中 = 4,
    REJECT = 4,
    // 出款成功
    SUCCESS = 5,
    // 取消
    FAILED = 6,
}

export enum CHANNEL_PAYMENT_TYPE {
    ALI_PAY = 'ALI_PAY',
    WECHAT_PAY = 'WECHAT_PAY',
    TO_PAY = 'TO_PAY',
    UNION_PAY = 'UNION_PAY',
    USDT_PAY = 'USDT_PAY',
    OK_PAY = 'OK_PAY',
    GO_PAY = 'GO_PAY',
    UPAY_PAY = 'UPAY_PAY',
}

export enum REVIEW_PAYMENT_TYPE {
    MANUAL = 0,
    PAYMENT = 1,
}

export enum TURNOVER_RESTRICTION_TYPE {
    NO_TURNOVER = 1,
    TURNOVER_AMOUNT_LIMIT = 2,
    TURNOVER_MULTIPLE_LIMIT = 3,
}

export enum ADJUSTMENT_TYPE {
    ACCOUNT = 1,
    RECHARGE = 2,
    WITHDRAW = 3,
    REBATE = 4,
    DIVIDEND = 5,
    BONUS = 6,
}

export enum UP_DOWN_TYPE {
    UP = 1,
    DOWN = 2,
}

export enum ADJUSTMENT_REVIEW_STATUS {
    WAIT = '0',
    LOCK = '-1',
    APPROVE = '1',
    REJECT = '2',
}

export enum ADJUSTMENT_TARGET {
    DESIGNATED_MEMBER = 0,
    BATCH_MEMBER = 1,
}
